











import { Component, Prop, Vue } from 'vue-property-decorator';
import { EverydayTrafficLight } from '../../models/EverydayTrafficLight';

@Component
export default class TrafficLight extends Vue {
    @Prop()
    private trafficLight!: EverydayTrafficLight;

    constructor() {
        super();
    }
}
